/**
 * @file       Students admin mixin, used by the whole admin module.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";

/**
 * Students admin mixin.
 *
 * @type  {Object}
 */
const adminStudentMixin = {
  computed: {
    ...mapState({
      user: state => state.admin.user.data,
      totalGrades: state =>
        state.admin.totalGrades.data.data.data.length != 0
          ? state.admin.totalGrades.data.data.data
          : {},
      profile: state =>
        state.auth.profile.data ? state.auth.profile.data.data.find(u => u) : {}
    }),

    /**
     * Check if current user is a teacher.
     *
     * @return     {bool}  true or false.
     */
    isTeacher() {
      return this.profile.role === "teacher";
    },

    /**
     * Check if current route is the arborescence graph.
     *
     * @return     {bool}  true or false.
     */
    routeIsArborescenceGraph() {
      return this.$route.name === "deliberation.arborescenceGraph";
    }
  }
};

export { adminStudentMixin };
